export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqData: FAQItem[] = [
  {
    id: 'faq-1',
    question: '久久网是什么类型的网站？',
    answer: '久久网是一个综合性网络内容平台，汇聚娱乐、资讯、科技、生活、教育、健康、财经、旅游等八大领域的优质内容资源，为用户提供便捷高效的一站式信息获取体验。无论是热门资讯、实用攻略还是深度分析，您都能在久久网找到所需内容。',
  },
  {
    id: 'faq-2',
    question: '久久网的内容是否免费？',
    answer: '是的，久久网所有内容完全免费向用户开放。我们致力于打造开放、共享的知识平台，让每一位用户都能平等地获取优质信息。您无需注册或付费，即可浏览全部文章和资源。',
  },
  {
    id: 'faq-3',
    question: '久久网的内容更新频率如何？',
    answer: '久久网保持每日更新的内容发布节奏，我们的编辑团队全天候关注各领域最新动态，确保用户能够在第一时间获取新鲜、有价值的资讯内容。热门栏目每日至少更新3-5篇优质文章。',
  },
  {
    id: 'faq-4',
    question: '如何在久久网上找到感兴趣的内容？',
    answer: '您可以通过多种方式在久久网找到感兴趣的内容：使用首页顶部的分类导航栏，按领域浏览文章；通过搜索框输入关键词进行精准搜索；在文章详情页查看"相关推荐"，发现更多相似内容。网站还提供热门排行和编辑精选，帮您发现优质内容。',
  },
  {
    id: 'faq-5',
    question: '久久网的内容来源可靠吗？',
    answer: '久久网高度重视内容质量与信息准确性。我们的内容由专业编辑团队严格审核，引用数据和事实均经过多方核实。同时，我们与多家权威媒体和行业专家建立了合作关系，确保为用户提供真实、可靠、有价值的资讯内容。',
  },
  {
    id: 'faq-6',
    question: '久久网有移动端APP吗？',
    answer: '久久网采用响应式网页设计，完美适配手机、平板和电脑等多种设备，您无需下载APP即可获得流畅的浏览体验。我们也在积极规划移动应用的开发，届时将为用户提供更加便捷的移动端服务。敬请期待！',
  },
  {
    id: 'faq-7',
    question: '我可以向久久网投稿或提供建议吗？',
    answer: '当然可以！久久网欢迎广大用户提供内容投稿和宝贵建议。如果您有优质的原创内容想要分享，或者对网站有任何改进建议，请通过"关于我们"页面的联系方式与我们取得联系。我们珍视每一位用户的声音。',
  },
];